import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'

export default function StatsBar() {
  const [stats, setStats] = useState({
    supporters: 0,
    chapters: 0,
    matches: 0,
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStats = async () => {
      const [
        { count: supporters },
        { count: chapters },
        { count: matches },
      ] = await Promise.all([
        supabase.from('clubs').select('*', { count: 'exact', head: true }),
        supabase.from('supporters').select('*', { count: 'exact', head: true }).eq('role', 'supporter'),
        supabase.from('chapters').select('*', { count: 'exact', head: true }),
        supabase.from('fixtures').select('*', { count: 'exact', head: true }).eq('status', 'completed'),
      ])

      setStats({
        supporters: supporters || 0,
        chapters: chapters || 0,
        matches: matches || 0,
      })
      setLoading(false)
    }
    fetchStats()
  }, [])

  const statItems = [
    {
      number: loading ? '—' : stats.supporters > 999
        ? `${(stats.supporters / 1000).toFixed(1)}k+`
        : `${stats.supporters}+`,
      label: 'Registered Supporters',
      sublabel: 'official members',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
    },
    {
      number: loading ? '—' : `${stats.chapters}`,
      label: 'Active Chapters',
      sublabel: 'across regions',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="2"/>
          <path d="M12 2a10 10 0 0 1 10 10"/>
          <path d="M12 2a10 10 0 0 0-10 10"/>
          <path d="M12 22a10 10 0 0 0 10-10"/>
          <path d="M12 22a10 10 0 0 1-10-10"/>
        </svg>
      ),
    },
    {
      number: loading ? '—' : `${stats.matches}`,
      label: 'Matches Played',
      sublabel: 'this season',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
          <line x1="2" y1="12" x2="22" y2="12"/>
        </svg>
      ),
    },
  ]

  return (
    <section className="relative mx-4 sm:mx-8 mt-8 sm:mt-12 z-10">
      <div className="bg-white dark:bg-gray-950 border border-gray-200 dark:border-white/10 shadow-xl dark:shadow-black/50 overflow-hidden">

        {/* Top accent bar */}
        <div className="h-1 bg-gradient-to-r from-green-600 via-green-400 to-green-600" />

        <div className="grid grid-cols-2 lg:grid-cols-3 divide-x divide-y lg:divide-y-0 divide-gray-100 dark:divide-white/5">
          {statItems.map((stat) => (
            <div
              key={stat.label}
              className="group relative px-5 sm:px-8 py-5 sm:py-8 hover:bg-green-50 dark:hover:bg-green-900/10 transition-colors duration-300 text-center"
            >
              {/* Icon */}
              <div className="text-green-500 dark:text-green-400 mb-2 sm:mb-3 opacity-60 group-hover:opacity-100 transition-opacity flex justify-center">
                {stat.icon}
              </div>

              {/* Number */}
              <div className="text-2xl sm:text-4xl lg:text-5xl font-black text-gray-900 dark:text-white tracking-tight leading-none mb-1">
                {stat.number}
              </div>

              {/* Label */}
              <div className="text-xs font-bold text-gray-900 dark:text-white uppercase tracking-widest mt-1 sm:mt-2 leading-tight">
                {stat.label}
              </div>

              {/* Sublabel */}
              <div className="text-xs text-gray-400 mt-0.5 hidden sm:block">
                {stat.sublabel}
              </div>

              {/* Bottom accent on hover */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-green-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}